import { BlockLinkList } from 'shared/api/client';
import { Link, TitleHtmlTag } from 'shared/types';
import { FormattedProps } from './types';
import { getLinkHref } from 'shared/helpers/uri';

export default function propsFormatter(
  content: BlockLinkList['content']
): FormattedProps {
  return {
    title: {
      label: content.title.label ?? '',
      htmlTag: content.title.htmlTag
        ? (content.title.htmlTag as TitleHtmlTag)
        : undefined
    },
    sections: content.sections.map(section => ({
      titleLabel: section.title,
      links: section.links.map(({ label, link }) => ({
        label,
        link: getLinkHref(link as Link)
      }))
    }))
  };
}
